import { LineWave } from "react-loader-spinner";
import CryptoJS from "crypto-js";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { MdDelete } from "react-icons/md";
//local imports
import {
  getPreviewBooks,
  updateBookApproval,
} from "../../../redux/slices/previewBooksSlice";
import RejectCommentModal from "./RejectComment";
import Confirmation from "../../../components/confirmation/Confirmation";
import { Tooltip } from "../sidekick-products/SideKickProducts";

const contentRatingMap = {
  TEEN: "/assets/images/Teen.svg",
  TWEEN: "/assets/images/Tween.svg",
  MATURE: "/assets/images/Mature.svg",
};

const PreviewBooks = () => {
  const dispatch = useDispatch();
  const { books, isLoading } = useSelector(
    (state) => state.previewBooksReducer
  );

  const [isOpenRejectionModal, setIsOpenRejectionModal] = useState(false);
  const [selectedDeclinedSlug, setSelectedDeclinedSlug] = useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [prductForDeletion, setPrductForDeletion] = useState("");
  const booksData = books?.data ?? [];
  const secretKey = process.env.REACT_APP_REVIEW_PRODUCT_KEY ?? "";
  const auth = Cookies.get("token");

  //functions

  const onClickApproveHandler = async (
    isApproved,
    slug,
    declineReason = ""
  ) => {
    const payload = {
      adminApproval: isApproved ? "approved" : "rejected",
      isPublished: isApproved,
      suggestion: declineReason,
      slug,
    };

    try {
      const response = await dispatch(updateBookApproval(payload));

      if (response?.payload?.code === 200) {
        await fetchBooksForPreview();
        toast.success(response?.payload?.message ?? "Data has been updated");
      } else {
        toast.error(
          response?.payload?.response?.data?.message,
          "Something went wrong"
        );
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
    setSelectedDeclinedSlug(null);
  };

  const fetchBooksForPreview = async () => {
    try {
      const response = await dispatch(getPreviewBooks());
      if (response?.payload?.code !== 200) {
        toast.error("Record not found");
      }
    } catch (error) {
      toast.error("Failed to fetch products");
    }
  };

  const openRejectionModalHandler = (slug) => {
    setSelectedDeclinedSlug(slug);
    setIsOpenRejectionModal(true);
  };

  const submitRejectionComment = (comment, slug) => {
    onClickApproveHandler(false, slug, comment);
    setIsOpenRejectionModal(false);
  };

  const displayPrice = (item) => {
    let priceDisplay = "";

    if (item?.price > 0) {
      if (item?.ticketPurchase) {
        priceDisplay = `$${item.price} or ${item?.ticketCost} ticket${
          item?.ticketCost === 1 ? "" : "s"
        }`;
      } else {
        priceDisplay = `$${item?.price}`;
      }
    } else if (item?.price === 0) {
      priceDisplay = "Free";
    } else {
      priceDisplay = "No Longer Available";
    }
    return priceDisplay;
  };

  const encryptData = (data, secretKey) => {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  const reviewRedirectHandler = (slug) => {
    const token = encryptData(auth, secretKey);
    const baseUrl = process.env.REACT_APP_API_SIDEKICK_APP_URL ?? "";
    const siteBUrl = `${baseUrl}/review-product?slug=${slug}&extToken=${encodeURIComponent(
      token
    )}`;
    window.location.href = siteBUrl;
  };

  const onClickDeleteProductHandler = (slug) => {
    setOpenConfirmationModal(true);
    setPrductForDeletion(slug);
  };

  const onDeleteProductHandler = async () => {
    const payload = {
      isDeleted: true,
      slug: prductForDeletion,
    };
    try {
      const response = await dispatch(updateBookApproval(payload));

      if (response?.payload?.code === 200) {
        await fetchBooksForPreview();
        toast.success("Product has been deleted successfully");
      } else {
        toast.error(
          response?.payload?.response?.data?.message,
          "Something went wrong"
        );
      }
    } catch (_error) {
      toast.error("Something went wrong");
    }
    setOpenConfirmationModal(false);
    setPrductForDeletion("");
  };

  const cancelModalHandler = () => {
    setOpenConfirmationModal(false);
    setPrductForDeletion("");
  };

  // effects

  useEffect(() => {
    fetchBooksForPreview();
  }, []);

  return (
    <>
    <h1 className="text-left text-white text-3xl font-bold ml-4">
      Approve Products
    </h1>
      <div
        className={`p-4 bg-[#150C3F] transition-all duration-300 h-full 
    }`}
      >
        <div className="library-wrapper grid grid-cols-6 max-xl:grid-cols-5 max-lg:grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1 w-full gap-y-8 max-xl:gap-y-6 max-md:gap-y-3  gap-x-4 max-xl:gap-x-5 max-md:gap-x-2.5 max-sm:gap-x-2.5">
          {booksData?.length > 0 ? (
            booksData?.map((item) => (
              <div
                key={item._id}
                className="flex flex-col group rounded-lg overflow-hidden duration-200 transition-color ease-linear"
              >
                <div
                  className={`my_lib ${
                    !item?.posterCompressUrl && !item?.posterUrl
                      ? "bg-[#211946]"
                      : ""
                  }`}
                >
                  <div className="relative h-[279px]">
                    <div className="">
                      {item?.posterCompressUrl || item?.posterUrl ? (
                        <img
                          src={item?.posterCompressUrl || item?.posterUrl}
                          alt={item?.poster}
                          className="object-cover group-hover:scale-105 duration-300 transition-all ease-linear"
                          style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: "0px",
                            color: "transparent",
                          }}
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center group-hover:scale-105 duration-300 transition-all ease-linear pt-[100px] text-white">
                          No Cover Image
                        </div>
                      )}
                    </div>
                    <div className="img_icon">
                      <img
                        src={
                          contentRatingMap[item?.contentRatings] ||
                          "/assets/images/Everyone.svg"
                        }
                        alt=""
                        className="absolute z-[10]  bottom-3 left-auto right-3 w-[31px] h-[46px]"
                      />
                    </div>
                  </div>
                </div>
                <div className="pb-[8px] px-[12px] bg-[#292A2E] min-h-[160px] flex flex-col justify-between">
                  <div className="flex-1">
                    <div className="flex items-start pt-[16px] relative w-full">
                      <h3 className="not-italic font-[700] text-left mb-2 text-white group-hover:text-sidekick-red-100 font-Poppins min-h-[60px] w-full break-words">
                        {item?.title}
                      </h3>
                    </div>
                    <div className="flex flex-wrap gap-2 mt-2 justify-between">
                      <h4 className="text-sm not-italic font-[400] text-white font-Poppins group-hover:text-sidekick-red-100 mb-2 text-left">
                        {displayPrice(item)}
                      </h4>
                      <Tooltip text="Delete">
                        <button
                          className="bg-red-600 text-white py-1 px-2 text-[12px] rounded-lg hover:bg-red-700 transition-colors duration-300 cursor-pointer"
                          onClick={() => {
                            onClickDeleteProductHandler(item?.slug);
                          }}
                        >
                          <MdDelete />
                        </button>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mt-2">
                    <button
                      className="text-white bg-yellow-600 px-2 py-1 rounded hover:bg-yellow-600 focus:outline-none text-sm inline-block"
                      onClick={() => {
                        reviewRedirectHandler(item?.slug);
                      }}
                    >
                      Review
                    </button>
                    <button
                      className="text-white bg-red-900 px-2 py-1 rounded hover:bg-red-900 focus:outline-none text-sm"
                      onClick={() => {
                        openRejectionModalHandler(item?.slug);
                      }}
                    >
                      Decline
                    </button>
                    <button
                      className="text-white bg-green-900 px-2 py-1 rounded hover:bg-green-900 focus:outline-none text-sm"
                      onClick={() => onClickApproveHandler(true, item?.slug)}
                    >
                      Approve
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 py-8 text-3xl w-[170px]">
              No Products Found
            </p>
          )}
        </div>
        {isLoading && (
          <div className="loader">
            <LineWave color={"#fff"} loading={isLoading} size={150} />
          </div>
        )}
      </div>
      {isOpenRejectionModal && (
        <RejectCommentModal
          slug={selectedDeclinedSlug}
          submitRejectionComment={submitRejectionComment}
          setIsOpenRejectionModal={setIsOpenRejectionModal}
        />
      )}
      {openConfirmationModal && (
        <Confirmation
          confirmDelete={onDeleteProductHandler}
          cancelDelete={cancelModalHandler}
          buttonText="Delete"
          message="delete this Product"
        />
      )}
    </>
  );
};

export default PreviewBooks;
